// SEO landing pages: pretty, indexable URLs targeting high-intent long-tail queries
// (budget + brand). Each renders a filtered catalog with unique title/H1/intro copy.
export const LANDINGS = {
  "iphone-pas-cher": {
    title: "iPhone pas cher reconditionné | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Achetez un iPhone reconditionné pas cher en Belgique & Luxembourg : testé, certifié et garanti 36 mois. Livraison 24-72 h, paiement en plusieurs fois avec Alma.",
    h1: "iPhone reconditionné pas cher",
    intro:
      "Nos iPhone reconditionnés offrent le meilleur rapport qualité-prix : chaque appareil est contrôlé sur plus de 40 points, garanti 36 mois et livré en Belgique, au Luxembourg et partout en Europe.",
    filter: { category: "iphone" },
    contentTitle: "Pourquoi choisir un iPhone reconditionné ?",
    content:
      "Un iPhone reconditionné, c'est le même modèle qu'au neuf, jusqu'à 40 % moins cher et bien plus écologique (≈ 70 kg de CO₂ évités). Chez Smarti Renew, batterie garantie à 85 % minimum, données 100 % effacées et reconditionnement réalisé en Belgique dans notre atelier. Choisissez votre grade (état) selon votre budget — tous nos iPhone sont couverts par une garantie de 36 mois.",
  },
  "iphone-moins-de-300-euros": {
    title: "iPhone reconditionné à moins de 300 € | Smarti Renew",
    metaDescription:
      "iPhone reconditionnés à moins de 300 € : garantis 36 mois, testés et livrés en 24-72 h en Belgique & Luxembourg. Le petit prix sans compromis sur la qualité.",
    h1: "iPhone reconditionné à moins de 300 €",
    intro:
      "Un iPhone fiable pour un budget serré : découvrez notre sélection d'iPhone reconditionnés à moins de 300 €, garantis 36 mois et prêts à l'emploi.",
    filter: { category: "iphone", pmax: 300 },
    contentTitle: "Le bon iPhone au bon prix",
    content:
      "En dessous de 300 €, nos iPhone reconditionnés restent parfaitement adaptés à un usage quotidien : appels, messages, réseaux sociaux et photo. Tous bénéficient de la même garantie 36 mois, d'une batterie contrôlée et d'un reconditionnement soigné.",
  },
  "reconditionne-moins-de-300-euros": {
    title: "Smartphones reconditionnés à moins de 300 € | Smarti Renew",
    metaDescription:
      "Smartphones reconditionnés (iPhone, Samsung) à moins de 300 €, garantis 36 mois. Livraison rapide partout en Europe, paiement en 3× sans frais.",
    h1: "Smartphones reconditionnés à moins de 300 €",
    intro:
      "Petit budget, grande qualité : notre sélection de smartphones reconditionnés à moins de 300 €, tous garantis 36 mois et livrés en 24-72 h.",
    filter: { pmax: 300 },
    contentTitle: "Le reconditionné malin",
    content:
      "Nos smartphones à moins de 300 € sont testés, certifiés et garantis 36 mois. iPhone ou Samsung, vous profitez d'un appareil fiable à prix mini, avec la sérénité d'une boutique belge et un service client réactif.",
  },
  "reconditionne-300-500-euros": {
    title: "Smartphones reconditionnés 300 – 500 € | Smarti Renew",
    metaDescription:
      "Le meilleur du reconditionné entre 300 et 500 € : iPhone & Samsung récents, garantis 36 mois, livrés partout en Europe.",
    h1: "Smartphones reconditionnés de 300 à 500 €",
    intro:
      "L'équilibre parfait entre performance et budget : des smartphones reconditionnés récents entre 300 et 500 €, garantis 36 mois.",
    filter: { pmin: 300, pmax: 500 },
    contentTitle: "Performance et budget maîtrisé",
    content:
      "Entre 300 et 500 €, vous accédez à des modèles récents et performants, idéaux pour la photo et le multitâche. Tous nos appareils sont garantis 36 mois et éligibles au paiement en plusieurs fois avec Alma.",
  },
  "reconditionne-500-700-euros": {
    title: "Smartphones reconditionnés 500 – 700 € | Smarti Renew",
    metaDescription:
      "Smartphones reconditionnés haut de gamme entre 500 et 700 € : iPhone Pro & Samsung Ultra, garantis 36 mois. Livraison partout en Europe.",
    h1: "Smartphones reconditionnés de 500 à 700 €",
    intro:
      "Le premium accessible : nos smartphones reconditionnés entre 500 et 700 €, pour les usages exigeants, garantis 36 mois.",
    filter: { pmin: 500, pmax: 700 },
    contentTitle: "Le premium, plus responsable",
    content:
      "Dans cette gamme, retrouvez les modèles Pro et Ultra les plus demandés. Un reconditionné premium vous fait économiser plusieurs centaines d'euros par rapport au neuf, tout en réduisant votre empreinte carbone.",
  },
  "samsung-pas-cher": {
    title: "Samsung Galaxy reconditionné pas cher | Smarti Renew",
    metaDescription:
      "Samsung Galaxy reconditionnés pas chers, garantis 36 mois et testés en Belgique. Livraison 24-72 h, paiement en plusieurs fois avec Alma.",
    h1: "Samsung Galaxy reconditionné pas cher",
    intro:
      "Découvrez nos Samsung Galaxy reconditionnés à petit prix : testés, certifiés et garantis 36 mois, livrés rapidement en Belgique, au Luxembourg et partout en Europe.",
    filter: { category: "samsung" },
    contentTitle: "Samsung reconditionné, la qualité au meilleur prix",
    content:
      "Nos Samsung Galaxy reconditionnés conjuguent puissance Android et prix réduit. Batterie contrôlée, données effacées et garantie 36 mois : l'assurance d'un smartphone fiable sans payer le prix du neuf.",
  },
  "iphone-reconditionne-belgique": {
    title: "iPhone reconditionné en Belgique | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "iPhone reconditionné en Belgique : testé sur 40+ points, batterie ≥85 %, garanti 36 mois. Livraison partout en Europe, retour 14 jours, paiement en plusieurs fois avec Alma.",
    h1: "iPhone reconditionné en Belgique",
    intro:
      "Achetez votre iPhone reconditionné en Belgique en toute confiance : chaque appareil est contrôlé, certifié et garanti 36 mois, avec livraison rapide en Belgique, au Luxembourg et partout en Europe.",
    filter: { category: "iphone" },
    contentTitle: "Votre iPhone reconditionné, livré en Belgique",
    content:
      "Basée à Arlon, Smarti Renew reconditionne et expédie des iPhone en Belgique, au Luxembourg et partout en Europe. Batterie garantie à 85 % minimum, données 100 % effacées, reconditionnement réalisé en Belgique dans notre atelier et garantie 36 mois — bien au-delà des standards du marché belge. Retrait possible en boutique à Arlon et paiement en 3× sans frais avec Alma.",
  },
  "smartphone-reconditionne-belgique": {
    title: "Smartphone reconditionné en Belgique | Atelier belge, garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphones reconditionnés en Belgique dans notre propre atelier, par nos techniciens réparateurs. Testés sur 40+ points, garantis 36 mois, livrés en Belgique, au Luxembourg et partout en Europe.",
    h1: "Smartphone reconditionné en Belgique, de qualité et garanti 36 mois",
    intro:
      "Chez Smarti Renew, chaque smartphone est reconditionné en Belgique, dans notre propre atelier, par nos techniciens réparateurs. Pas une marketplace de vendeurs tiers : un seul atelier belge, responsable de chaque appareil.",
    filter: { category: "smartphones" },
    contentTitle: "Un reconditionné belge, contrôlé de bout en bout",
    content:
      "Diagnostic complet, remplacement des pièces nécessaires, batterie garantie à 85 % minimum, effacement certifié des données : tout est fait en Belgique, dans notre atelier. Résultat : une garantie de 36 mois, là où le marché propose généralement 12 à 24 mois. Livraison suivie en Belgique, au Luxembourg et partout en Europe, retour 14 jours et paiement en 3× sans frais avec Alma.",
  },
  "smartphone-reconditionne-wallonie": {
    title: "iPhone & smartphone reconditionné en Wallonie | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone et iPhone reconditionnés en Wallonie par un atelier belge : contrôlés sur 40+ points, garantis 36 mois, livrés en 24-72 h à Liège, Namur, Charleroi, Mons, Arlon et partout en Wallonie.",
    h1: "iPhone et smartphone reconditionnés en Wallonie",
    intro:
      "Un reconditionné wallon et belge de qualité : nos techniciens réparent et contrôlent chaque appareil dans notre atelier en Belgique, puis nous le livrons partout en Wallonie en 24-72 h.",
    filter: { category: "smartphones" },
    contentTitle: "Pourquoi choisir un reconditionné belge en Wallonie ?",
    content:
      "Acheter chez un reconditionneur belge, c'est savoir qui a réparé votre téléphone : notre propre équipe, dans notre atelier. Chaque iPhone et Samsung est garanti 36 mois, livré en envoi suivi à Liège, Namur, Charleroi, Mons, Arlon ou ailleurs en Wallonie, avec retour 14 jours et paiement en plusieurs fois.",
  },

  "samsung-reconditionne-belgique": {
    title: "Samsung Galaxy reconditionné en Belgique | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Samsung Galaxy reconditionné en Belgique : testé, certifié et garanti 36 mois. Livraison partout en Europe, retour 14 jours, paiement en plusieurs fois.",
    h1: "Samsung Galaxy reconditionné en Belgique",
    intro:
      "Découvrez nos Samsung Galaxy reconditionnés livrés en Belgique, au Luxembourg et partout en Europe : testés, certifiés et garantis 36 mois, prêts à l'emploi.",
    filter: { category: "samsung" },
    contentTitle: "Samsung reconditionné, expédié en Belgique",
    content:
      "Puissance Android à prix réduit : nos Samsung Galaxy reconditionnés sont contrôlés sur plus de 40 points, batterie vérifiée et données effacées. Garantie 36 mois, livraison en Belgique, au Luxembourg et partout en Europe, et service client belge réactif.",
  },
  "google-pixel-reconditionne-belgique": {
    title: "Google Pixel reconditionné en Belgique | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Google Pixel reconditionné en Belgique : testé, certifié et garanti 36 mois. Livraison partout en Europe, retour 14 jours. L'Android pur au meilleur prix.",
    h1: "Google Pixel reconditionné en Belgique",
    intro:
      "Le meilleur de l'Android pur, à prix reconditionné : nos Google Pixel sont testés, certifiés et garantis 36 mois, livrés rapidement en Belgique, au Luxembourg et partout en Europe.",
    filter: { category: "google" },
    contentTitle: "Google Pixel reconditionné, livré en Belgique",
    content:
      "Les Google Pixel reconditionnés offrent une expérience Android épurée, un excellent appareil photo et des mises à jour longue durée. Chaque Pixel est reconditionné en Belgique, batterie garantie à 85 % minimum, données effacées et couvert par notre garantie 36 mois. Livraison en Belgique, au Luxembourg et partout en Europe.",
  },

  // ── Pages SEO locales (une page unique par ville, contenu distinct) ──
  "smartphone-reconditionne-arlon": {
    title: "Smartphone reconditionné à Arlon | Boutique & garantie 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné à Arlon : notre boutique vous accueille au chef-lieu de la province de Luxembourg. iPhone & Samsung testés, garantis 36 mois, retrait immédiat en magasin ou livraison 24-72 h.",
    h1: "Smartphone reconditionné à Arlon",
    intro:
      "Arlonais, c'est chez vous que tout commence : notre atelier et notre boutique Smarti Renew sont installés à Arlon. Venez choisir votre iPhone ou Samsung reconditionné en main propre, ou faites-vous livrer en 24-72 h.",
    filter: { category: "smartphones" },
    city: "Arlon",
    contentTitle: "Votre boutique de reconditionné à Arlon",
    content:
      "Basés à Arlon, nous reconditionnons chaque smartphone sur place puis le testons sur plus de 40 points. Habitant d'Arlon ou des environs (Weyler, Bonnert, Autelbas), profitez du retrait gratuit en boutique le jour même, d'un conseil en français et d'une reprise de votre ancien appareil déductible immédiatement. Tous nos appareils sont garantis 36 mois, batterie contrôlée à 85 % minimum et données effacées.",
  },
  "smartphone-reconditionne-libramont": {
    title: "Smartphone reconditionné à Libramont | Livraison 24-72 h — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Libramont-Chevigny : iPhone & Samsung garantis 36 mois, testés et expédiés en 24-72 h. Retrait possible à Arlon, à ~45 km.",
    h1: "Smartphone reconditionné à Libramont",
    intro:
      "Au cœur de l'Ardenne, Libramont-Chevigny reçoit ses smartphones reconditionnés en 24-72 h. Commandez en ligne et faites-vous livrer, ou venez retirer votre appareil dans notre boutique d'Arlon, à environ 45 km.",
    filter: { category: "smartphones" },
    city: "Libramont-Chevigny",
    contentTitle: "Le reconditionné livré à Libramont",
    content:
      "Que vous soyez à Libramont, Recogne ou Bras, votre iPhone ou Samsung reconditionné arrive chez vous en 24-72 h via envoi suivi. Reconditionnés en Belgique et garantis 36 mois, nos smartphones sont une alternative maligne et durable au neuf. Paiement en 3× sans frais avec Alma et reprise de votre ancien téléphone possible.",
  },
  "smartphone-reconditionne-bastogne": {
    title: "Smartphone reconditionné à Bastogne | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné à Bastogne : iPhone & Samsung certifiés, garantis 36 mois, livrés en 24-72 h. Boutique et atelier à Arlon (~42 km).",
    h1: "Smartphone reconditionné à Bastogne",
    intro:
      "Bastogne et toute la région du Pays de Bastogne profitent de nos smartphones reconditionnés livrés en 24-72 h. Un appareil fiable, garanti 36 mois, au meilleur prix.",
    filter: { category: "smartphones" },
    city: "Bastogne",
    contentTitle: "Un smartphone fiable à Bastogne",
    content:
      "De Bastogne à Wardin ou Noville, recevez un iPhone ou un Samsung reconditionné testé sur plus de 40 points et garanti 36 mois. Nous sommes basés à Arlon, à environ 42 km : le retrait en boutique reste possible pour ceux qui préfèrent le contact direct. Batterie garantie à 85 %, données effacées, service client belge réactif.",
  },
  "smartphone-reconditionne-marche-en-famenne": {
    title: "Smartphone reconditionné à Marche-en-Famenne | Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Marche-en-Famenne : iPhone & Samsung garantis 36 mois, testés et expédiés en 24-72 h en Belgique.",
    h1: "Smartphone reconditionné à Marche-en-Famenne",
    intro:
      "Capitale de la Famenne, Marche-en-Famenne reçoit ses smartphones reconditionnés en quelques jours. Commandez en ligne, on s'occupe du reste.",
    filter: { category: "smartphones" },
    city: "Marche-en-Famenne",
    contentTitle: "Le reconditionné en Famenne",
    content:
      "Nos smartphones reconditionnés sont livrés à Marche-en-Famenne et dans toute la Famenne (Aye, Hargimont, On) en 24-72 h. Chaque iPhone et Samsung est reconditionné en Belgique, garanti 36 mois et livré prêt à l'emploi. Un choix économique et écologique, avec paiement en plusieurs fois et reprise possible.",
  },
  "smartphone-reconditionne-neufchateau": {
    title: "Smartphone reconditionné à Neufchâteau | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné à Neufchâteau : iPhone & Samsung testés, garantis 36 mois, livrés en 24-72 h. Atelier à Arlon (~35 km).",
    h1: "Smartphone reconditionné à Neufchâteau",
    intro:
      "Neufchâteau et sa région reçoivent nos smartphones reconditionnés en 24-72 h, avec la même garantie 36 mois que sur le neuf le plus premium.",
    filter: { category: "smartphones" },
    city: "Neufchâteau",
    contentTitle: "Le reconditionné à Neufchâteau",
    content:
      "À Neufchâteau comme à Longlier ou Grandvoir, offrez-vous un iPhone ou un Samsung reconditionné sans exploser votre budget. Nous sommes à environ 35 km, à Arlon, où se trouvent notre atelier et notre boutique. Appareils contrôlés sur 40+ points, batterie ≥85 %, garantie 36 mois et données 100 % effacées.",
  },
  "smartphone-reconditionne-virton": {
    title: "Smartphone reconditionné à Virton | Gaume — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné à Virton (Gaume) : iPhone & Samsung garantis 36 mois, testés et livrés en 24-72 h. Boutique à Arlon (~30 km).",
    h1: "Smartphone reconditionné à Virton",
    intro:
      "En pleine Gaume, Virton profite de nos smartphones reconditionnés livrés rapidement, ou à retirer à Arlon à une trentaine de kilomètres.",
    filter: { category: "smartphones" },
    city: "Virton",
    contentTitle: "Le reconditionné en Gaume, à Virton",
    content:
      "La Gaube mérite le meilleur du reconditionné : à Virton, Saint-Mard ou Ethe, recevez un iPhone ou un Samsung testé, certifié et garanti 36 mois. Livraison 24-72 h, retrait possible dans notre boutique d'Arlon, reprise de votre ancien appareil et paiement en 3× avec Alma. Un smartphone comme neuf, en plus responsable.",
  },
  "smartphone-reconditionne-bertrix": {
    title: "Smartphone reconditionné à Bertrix | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Bertrix : iPhone & Samsung certifiés, garantis 36 mois, expédiés en 24-72 h en Belgique.",
    h1: "Smartphone reconditionné à Bertrix",
    intro:
      "Bertrix reçoit ses smartphones reconditionnés en 24-72 h : un appareil fiable et garanti 36 mois, sans payer le prix du neuf.",
    filter: { category: "smartphones" },
    city: "Bertrix",
    contentTitle: "Le reconditionné à Bertrix",
    content:
      "À Bertrix et dans les villages alentour, nos iPhone et Samsung reconditionnés arrivent chez vous prêts à l'emploi. Reconditionnement européen, batterie garantie à 85 % minimum, données effacées et garantie 36 mois bien au-delà des standards du marché. Notre boutique d'Arlon reste à votre disposition pour un retrait ou un conseil.",
  },
  "smartphone-reconditionne-habay": {
    title: "Smartphone reconditionné à Habay | Proche Arlon — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné à Habay, à seulement ~20 km d'Arlon : iPhone & Samsung garantis 36 mois, retrait rapide ou livraison 24-72 h.",
    h1: "Smartphone reconditionné à Habay",
    intro:
      "Habay est à deux pas de notre boutique d'Arlon (~20 km) : retrait express ou livraison 24-72 h, à vous de choisir. Smartphones reconditionnés garantis 36 mois.",
    filter: { category: "smartphones" },
    city: "Habay",
    contentTitle: "Le reconditionné tout près, à Habay",
    content:
      "De Habay-la-Neuve à Habay-la-Vieille, profitez de la proximité de notre atelier d'Arlon pour un retrait rapide de votre iPhone ou Samsung reconditionné. Tous nos appareils sont testés sur plus de 40 points, garantis 36 mois, avec batterie contrôlée et données effacées. Reprise et paiement en plusieurs fois disponibles.",
  },
  "smartphone-reconditionne-aubange": {
    title: "Smartphone reconditionné à Aubange & Athus | Smarti Renew",
    metaDescription:
      "Smartphone reconditionné à Aubange / Athus, proche de la frontière luxembourgeoise : iPhone & Samsung garantis 36 mois, livrés en 24-72 h. Arlon à ~18 km.",
    h1: "Smartphone reconditionné à Aubange",
    intro:
      "Aubange, Athus et la région des Trois Frontières reçoivent nos smartphones reconditionnés en 24-72 h. Notre boutique d'Arlon n'est qu'à ~18 km.",
    filter: { category: "smartphones" },
    city: "Aubange",
    contentTitle: "Le reconditionné à Aubange, aux Trois Frontières",
    content:
      "Aux portes du Grand-Duché, à Aubange et Athus, offrez-vous un iPhone ou un Samsung reconditionné garanti 36 mois. Nous reconditionnons et testons chaque appareil dans notre atelier d'Arlon, tout proche. Batterie ≥85 %, données 100 % effacées, retrait en boutique et reprise de votre ancien téléphone possibles.",
  },
  "smartphone-reconditionne-durbuy": {
    title: "Smartphone reconditionné à Durbuy | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Durbuy : iPhone & Samsung testés, garantis 36 mois, expédiés en 24-72 h partout en Belgique.",
    h1: "Smartphone reconditionné à Durbuy",
    intro:
      "De la plus petite ville du monde aux villages de l'Ourthe, Durbuy reçoit nos smartphones reconditionnés livrés en 24-72 h, garantis 36 mois.",
    filter: { category: "smartphones" },
    city: "Durbuy",
    contentTitle: "Le reconditionné livré à Durbuy",
    content:
      "À Durbuy, Barvaux ou Bomal, un smartphone reconditionné c'est jusqu'à 40 % d'économie et un vrai geste pour la planète. Chaque iPhone et Samsung est reconditionné en Belgique et garanti 36 mois. Livraison suivie en 24-72 h, paiement en 3× sans frais avec Alma et reprise de votre ancien appareil déductible.",
  },
  "smartphone-reconditionne-saint-hubert": {
    title: "Smartphone reconditionné à Saint-Hubert | Smarti Renew",
    metaDescription:
      "Smartphone reconditionné à Saint-Hubert : iPhone & Samsung garantis 36 mois, testés et livrés en 24-72 h en Belgique.",
    h1: "Smartphone reconditionné à Saint-Hubert",
    intro:
      "Saint-Hubert, capitale européenne de la nature, profite de nos smartphones reconditionnés fiables et garantis 36 mois, livrés en quelques jours.",
    filter: { category: "smartphones" },
    city: "Saint-Hubert",
    contentTitle: "Le reconditionné à Saint-Hubert",
    content:
      "Au cœur de l'Ardenne, à Saint-Hubert et alentour, recevez un iPhone ou un Samsung reconditionné testé sur plus de 40 points et garanti 36 mois. Batterie contrôlée, données effacées, reconditionnement européen : la sérénité d'un appareil comme neuf à prix réduit, avec un service client belge à votre écoute.",
  },
  "smartphone-reconditionne-la-roche-en-ardenne": {
    title: "Smartphone reconditionné à La Roche-en-Ardenne | Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à La Roche-en-Ardenne : iPhone & Samsung garantis 36 mois, testés, expédiés en 24-72 h.",
    h1: "Smartphone reconditionné à La Roche-en-Ardenne",
    intro:
      "La perle de l'Ardenne reçoit nos smartphones reconditionnés en 24-72 h : un appareil garanti 36 mois, prêt à vous suivre sur les hauteurs de l'Ourthe.",
    filter: { category: "smartphones" },
    city: "La Roche-en-Ardenne",
    contentTitle: "Le reconditionné à La Roche-en-Ardenne",
    content:
      "Que vous soyez à La Roche, Beausaint ou Ortho, votre iPhone ou Samsung reconditionné arrive chez vous testé, certifié et garanti 36 mois. Reconditionnés en Europe, nos appareils affichent une batterie garantie à 85 % minimum et des données 100 % effacées. Paiement en plusieurs fois et reprise de votre ancien téléphone disponibles.",
  },
  "smartphone-reconditionne-luxembourg-ville": {
    title: "Smartphone reconditionné à Luxembourg-Ville | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Luxembourg-Ville : iPhone & Samsung certifiés, garantis 36 mois, expédiés rapidement au Grand-Duché. Atelier à Arlon (~30 km).",
    h1: "Smartphone reconditionné à Luxembourg-Ville",
    intro:
      "La capitale du Grand-Duché profite de nos smartphones reconditionnés premium, livrés rapidement et garantis 36 mois. Notre boutique d'Arlon est à ~30 km, juste de l'autre côté de la frontière.",
    filter: { category: "smartphones" },
    city: "Luxembourg",
    contentTitle: "Le reconditionné à Luxembourg-Ville",
    content:
      "De Kirchberg au Limpertsberg, offrez-vous un iPhone ou un Samsung reconditionné sans payer le prix du neuf. Frontaliers et résidents luxembourgeois profitent d'une livraison rapide au Grand-Duché et de la possibilité de retirer leur appareil à Arlon, tout proche. Tous nos smartphones sont garantis 36 mois, batterie contrôlée et données effacées.",
  },
  "smartphone-reconditionne-esch-sur-alzette": {
    title: "Smartphone reconditionné à Esch-sur-Alzette | Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Esch-sur-Alzette : iPhone & Samsung garantis 36 mois, testés et expédiés rapidement au Luxembourg.",
    h1: "Smartphone reconditionné à Esch-sur-Alzette",
    intro:
      "Deuxième ville du Grand-Duché, Esch-sur-Alzette reçoit nos smartphones reconditionnés premium, garantis 36 mois et livrés rapidement.",
    filter: { category: "smartphones" },
    city: "Esch-sur-Alzette",
    contentTitle: "Le reconditionné à Esch-sur-Alzette",
    content:
      "À Esch-sur-Alzette et dans le sud du Luxembourg, un smartphone reconditionné est le choix malin : jusqu'à 40 % d'économie et une empreinte carbone réduite. Nos iPhone et Samsung sont reconditionnés en Europe, testés sur 40+ points et garantis 36 mois. Livraison rapide au Grand-Duché, retrait possible à Arlon et reprise de votre ancien appareil.",
  },
  "smartphone-reconditionne-namur": {
    title: "Smartphone reconditionné à Namur | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Namur : iPhone & Samsung testés, garantis 36 mois, expédiés en 24-72 h partout en Wallonie.",
    h1: "Smartphone reconditionné à Namur",
    intro:
      "Capitale de la Wallonie, Namur reçoit nos smartphones reconditionnés en 24-72 h : la qualité premium d'une boutique belge, garantie 36 mois.",
    filter: { category: "smartphones" },
    city: "Namur",
    contentTitle: "Le reconditionné livré à Namur",
    content:
      "De la Citadelle au centre-ville, à Jambes ou Bouge, recevez un iPhone ou un Samsung reconditionné garanti 36 mois, livré en 24-72 h. Reconditionnement européen, batterie garantie à 85 % minimum, données effacées et paiement en 3× sans frais avec Alma. Une alternative fiable et durable au neuf, avec un service client 100 % en français.",
  },
  "smartphone-reconditionne-liege": {
    title: "Smartphone reconditionné à Liège | Garanti 36 mois — Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Liège : iPhone & Samsung certifiés, garantis 36 mois, expédiés en 24-72 h. Le reconditionné premium, livré dans la Cité Ardente.",
    h1: "Smartphone reconditionné à Liège",
    intro:
      "La Cité Ardente reçoit nos smartphones reconditionnés en 24-72 h : iPhone et Samsung testés, certifiés et garantis 36 mois, à prix reconditionné.",
    filter: { category: "smartphones" },
    city: "Liège",
    contentTitle: "Le reconditionné livré à Liège",
    content:
      "À Liège comme à Herstal, Seraing ou Ans, un smartphone reconditionné vous fait économiser plusieurs centaines d'euros tout en réduisant les déchets électroniques. Chaque appareil est reconditionné en Europe, garanti 36 mois, batterie contrôlée et données 100 % effacées. Livraison suivie 24-72 h et reprise de votre ancien téléphone déductible de votre commande.",
  },
  "smartphone-reconditionne-bouillon": {
    title: "Smartphone reconditionné à Bouillon | Smarti Renew",
    metaDescription:
      "Smartphone reconditionné livré à Bouillon : iPhone & Samsung garantis 36 mois, testés et expédiés en 24-72 h en Belgique.",
    h1: "Smartphone reconditionné à Bouillon",
    intro:
      "Au bord de la Semois, Bouillon reçoit nos smartphones reconditionnés fiables, garantis 36 mois et livrés en 24-72 h.",
    filter: { category: "smartphones" },
    city: "Bouillon",
    contentTitle: "Le reconditionné livré à Bouillon",
    content:
      "De la cité du château fort aux villages de la Semois, votre iPhone ou Samsung reconditionné arrive chez vous testé, certifié et garanti 36 mois. Batterie garantie à 85 % minimum, données effacées et reconditionnement européen : un appareil comme neuf, plus responsable et moins cher. Paiement en plusieurs fois et reprise possibles.",
  },
};
